import { render, staticRenderFns } from "./AButton.vue?vue&type=template&id=7fa890f2&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=js"
export * from "./AButton.vue?vue&type=script&lang=js"
import style0 from "./AButton.vue?vue&type=style&index=0&id=7fa890f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa890f2",
  null
  
)

export default component.exports